import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { _AccountResume, _AnnotationReport } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectTHConstantsValue } from "../../../bpm/config/Componentes/SelectTHConstantsValue";
import { SelectFunctionalID } from "../../../admin/configuracion/functionalID/SelectFunctionalID";
import { FileInput } from "../../../theme/Component/FileInput";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AcademicEducationAccount } from "./AcademicEducationAccount/AcademicEducationAccount";
import { WorkExperienceAccount } from "./WorkExperienceAccount/WorkExperienceAccount";
import { Certifications } from "./Certifications/Certifications";
import { PersonalReferences } from "./PersonalReferences/PersonalReferences";
import { PersonDocuments } from "./PersonDocuments/PersonDocuments";
import usePaginator from "../../../theme/Component/usePaginator";


export const AccountResume = () => {

    const AccountResume = useDataBean(_AccountResume);

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modalinfo, setModalinfo] = useState<any>({ name: 'Información', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalhistorial, setModalhistorial] = useState<any>({ name: 'Historial', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcerti, setModalcerti] = useState<any>({ name: 'Certificaciones', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalref, setModalref] = useState<any>({ name: 'Referencias', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldoc, setModaldoc] = useState<any>({ name: 'Documento', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [Account, setAccount] = useState<any>(null)
    const paginador = usePaginator();
    useEffect(() => {
        getListavdos();
    }, [])
    const getLista = () => {

        AccountResume.instance.getAccountResumeCatalogPorPropiedades({ State: 1, IDAccount: Account }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }

    const getListavdos = () => {

        AccountResume.instance.getAccountResumeReport(paginador.page, 15, { State: 1, IDAccount: Account }).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }

            }
        )

    }



    const create = () => {
        AccountResume.setBean({
            IDAccount: AccountResume.bean.IDAccount,
            State: 1,
            IDEmployee: _single.getAccountID(),

        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        AccountResume.update().then(
            (resp: any) => {
                getListavdos();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        AccountResume.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }




    const head = [
        { title: 'ID', property: 'IDAccountResume', visible: true },
        { title: 'Funcionario', property: 'EntityAccount', visible: true },
        { title: 'Nit', property: 'Nit', visible: true },
        { title: 'eMail', property: 'eMail', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        // { title: 'Usuario Logueado', property: 'IDEmployee', visible: true },


    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Informacion Academica', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalinfo({ ...modalinfo, "view": true }) } },
            { titulo: 'Historial de Empleo', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalhistorial({ ...modalhistorial, "view": true }) } },
            { titulo: 'Certificaciones', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalcerti({ ...modalcerti, "view": true }) } },
            { titulo: 'Referencias Personales', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalref({ ...modalref, "view": true }) } },
            { titulo: 'Documento Soportes', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModaldoc({ ...modaldoc, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Hoja de Vida">
            <div className="row">
                <div className="col-md-6">
                    <AccountEditor label="Funcionario" idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }}></AccountEditor>
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-search-eye-line" clase="btn rounded-pill btn-primary waves-effect waves-light" eventClick={getListavdos}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={AccountResume.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <AccountEditor label="Agregar Funcionario" idAccount={AccountResume.bean.IDAccount} onChange={(e) => { AccountResume.setBean({ ...AccountResume.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                                </div>

                            </div>


                        </>
                    </Modal>
                    <Modal modal={modalinfo} updateModal={setModalinfo}>
                        <>
                            <div className="col-md-12">
                                <AcademicEducationAccount Account={AccountResume.bean.IDAccount} />
                            </div>
                        </>
                    </Modal>
                    <Modal modal={modalhistorial} updateModal={setModalhistorial}>
                        <>
                            <div className="col-md-12">
                                <WorkExperienceAccount Account={AccountResume.bean.IDAccount} />
                            </div>
                        </>
                    </Modal>
                    <Modal modal={modalcerti} updateModal={setModalcerti}>
                        <>
                            <div className="col-md-12">
                                <Certifications Account={AccountResume.bean.IDAccount} />
                            </div>
                        </>
                    </Modal>
                    <Modal modal={modalref} updateModal={setModalref}>
                        <>
                            <div className="col-md-12">
                                <PersonalReferences Account={AccountResume.bean.IDAccount} />
                            </div>
                        </>
                    </Modal>
                    <Modal modal={modaldoc} updateModal={setModaldoc}>
                        <>
                            <div className="col-md-12">
                                <PersonDocuments Account={AccountResume.bean.IDAccount} />

                            </div>
                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}